import "./App.css";
import Moreworks from "./components/Moreworks";
import Main from "./components/Main";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/works" element={<Moreworks />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
